<template>
  <div class="liveOpenClass">
    <div class="liveCon">
      <!-- 直播公开课 -->
      <div class="animate__animated animate__pulse liveCon-left">
        <talentTitle title="直播公开课">
          <template #btn>
            <div class="curp" @click="onClickLiveMore">查看更多</div>
          </template>
        </talentTitle>
        <div class="courseOrService">
          <div
            v-for="(item, index) in liveList"
            :key="index"
            class="courseItem"
            @click="onClickDetail(item)"
          >
            <div class="courseItem-bg" :style="{ backgroundImage: `url(${item.pic})` }">
              <!-- {{ item.title }} -->
              <img v-if="!item.pic" class="emptyBg" src="../../assets/publicService/empty.jpg" alt />
            </div>
            <div class="courseItem-profile">
              <div class="courseItem-profile-name over-num-lines">{{ item.title }}</div>
              <div class="courseItem-profile-time">{{ item.startDate | dateFormat }}</div>
            </div>
          </div>
          <div v-if="liveList.length == 0" class="empty">暂无数据</div>
        </div>
      </div>
      <!-- 分隔线 -->
      <!-- <div class="animate__animated animate__fadeInUp dividerLine"></div> -->
      <!-- 职称评审服务 -->
      <div class="animate__animated animate__pulse liveCon-right">
        <talentTitle title="职称评审服务">
          <template #subTitle>
            <div class="subtitle">（建设工程专业、经济系列、工艺美术系列）</div>
          </template>
        </talentTitle>
        <div class="courseOrService">
          <div class="serviceItem" @click="detail('1')">
            <div class="title">
              申报入口
              <div class="profile">职称咨询电话：8801899</div>
            </div>
            <div class="arrow"></div>
          </div>
          <div class="serviceItem" @click="goPayEntrance">
            <div class="title" style="color:#fff">
              缴费入口
              <div class="profile" style="color:#A6D1F6">请申报后在这里缴费</div>
            </div>
            <div class="arrow"></div>
          </div>
          <div class="serviceItem" @click="detail('2')">
            <div class="title">历年职称任职文件查询</div>
            <div class="arrow"></div>
          </div>
          <div class="serviceItem" @click="detail('3')">
            <div class="title">
              宁夏回族自治区
              <br />人力资源和社会保障厅
            </div>
            <div class="arrow"></div>
          </div>
          <div class="serviceItem" @click="detail('4')">
            <div class="title">
              宁夏专业技术人员
              <br />继续教育培训网
            </div>
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import talentTitle from "./talentTitle.vue";
import { queryLive } from "../../utils/interface";
export default {
  name: "liveOpenClass",
  components: { talentTitle },
  props: {},
  data() {
    return {
      liveList: [
        {
          pic: require("../../assets/publicService/57.png"),
          title: "安全标准化创建方法",
          startDate: "2023-06-11"
        },
        {
          pic: require("../../assets/publicService/58.png"),
          title: "安全标准化创建方法",
          startDate: "2023-06-11"
        },
        {
          pic: require("../../assets/publicService/58.png"),
          title: "安全标准化创建方法",
          startDate: "2023-06-11"
        },
        {
          pic: require("../../assets/publicService/57.png"),
          title: "安全标准化创建方法",
          startDate: "2023-06-11"
        }
      ]
    };
  },
  watch: {},
  filters: {
    dateFormat(str) {
      if (str) {
        return str.split(" ")[0];
      } else {
        return;
      }
    }
  },
  created() {},
  mounted() {
    this.GKKqueryLive();
  },
  methods: {
    /* 进入缴费入口 */
    goPayEntrance() {
      let router = this.$router.resolve({
        path: "/payEnterance"
      });
      window.open(router.href, "_blank");
    },
    // 查询直播公开课
    GKKqueryLive() {
      queryLive({
        current: 1,
        pageSize: 4,
        status: 1,
        rec: 1,
        programUuid: "ZB_GKK",
        stage: "" //(NOT_START-未开始，DOING-进行中，END-已结束，全部-'')
      }).then(res => {
        if (res && res.list.length > 0) {
          this.liveList = res.list;
        } else {
          this.liveList = [];
        }
      });
    },
    // 直播公开课-查看更多
    onClickLiveMore() {
      let route = this.$router.resolve({
        path: "/liveOpenList"
      });
      window.open(route.href, "_blank");
    },
    // 直播公开课详情
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        path: "/liveOpenDetail",
        query: {
          uuid: item.uuid,
          type: "live",
          titleName: "直播列表",
          titleForm: "liveOpenList"
        }
      });
      window.open(routeData.href, "_blank");
    },
    //
    detail(msg) {
      if (msg == "1") {
        window.open("http://222.75.70.73:8001/zcps/", "_blank");
      } else if (msg == "2") {
        // window.open('http://106.75.100.14:8080/#/', '_blank')
        window.open(`${location.origin}/newsConsult?index=3`, "_blank");
      } else if (msg == "3") {
        window.open("http://hrss.nx.gov.cn/", "_blank");
      } else if (msg == "4") {
        window.open("https://nxzj.chinahrt.com/", "_blank");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.liveOpenClass {
  height: 480px;
  background-color: #f6f6f6;

  .curp {
    cursor: pointer;

    &:hover {
      color: #2d50a1;
    }
  }

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .liveCon {
    width: 1300px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .dividerLine {
      height: 450px;
      border-right: 0.5px solid #e4e4e4;
    }

    .liveCon-left,
    .liveCon-right {
      width: 630px;
      height: 460px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: start;

      .courseOrService {
        height: 420px;
        padding: 0px 10px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: start;
      }

      .subtitle {
        color: #3a3a3a;
        font-size: 15px;
      }
    }

    .liveCon-left {
      .courseOrService {
        .courseItem {
          width: 297px;
          height: 195px;
          background-size: 100% 100%;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 0 1px #999;
          transition: all 0.2s;
          margin-top: 4px;

          &:hover {
            transform: scale(1.02);
            cursor: pointer;
          }

          .courseItem-bg {
            height: 140px;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            display: flex;
            align-items: center;
            text-align: center;
            font-size: 28px;
            font-weight: 600;
            color: #fff;
            padding: 0 40px;
            background: no-repeat center center/100% 100%;

            .emptyBg {
              width: 210px;
              height: 140px;
              position: absolute;
              background: no-repeat center center/100% 100%;
            }
          }

          .courseItem-profile {
            flex: 1;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            padding: 0 15px;
            border-bottom-left-radius: 18px;
            border-bottom-right-radius: 18px;
            background-color: #fff;

            .courseItem-profile-name {
              width: 170px;
              color: #000;
              font-weight: 600;
            }

            .courseItem-profile-time {
              width: 80px;
              font-size: 14px;
              color: #868686;
              font-weight: 500;
            }
          }
        }
      }
    }

    .liveCon-right {
      .courseOrService {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: start;
        padding-top: 4px;

        .serviceItem {
          width: 297px;
          height: 140px;
          background-size: 100% 100%;
          padding: 25px;
          box-sizing: border-box;
          display: flex;
          flex-flow: column nowrap;
          justify-content: space-between;
          transition: all 0.2s;
          background: no-repeat center center/100% 100%;

          &:nth-of-type(1) {
            background-image: url("../../assets//publicService/talentService/3.png");
          }

          &:nth-of-type(2) {
            background-image: url("../../assets//publicService/talentService/4.png");
          }

          &:nth-of-type(3) {
            width: 610px;
            height: 100px;
            background-image: url("../../assets//publicService/talentService/7.png");
            padding: 20px 25px;
          }

          &:nth-of-type(4) {
            background-image: url("../../assets//publicService/talentService/5.png");
          }

          &:nth-of-type(5) {
            background-image: url("../../assets//publicService/talentService/6.png");
          }

          .title {
            color: #000;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.5;

            .profile {
              color: #426286;
              font-size: 15px;
            }
          }

          .arrow {
            width: 26px;
            height: 26px;
            background: url("../../assets/publicService/talentService/2.png");
          }

          &:hover {
            transform: scale(1.02);
            cursor: pointer;

            .arrow {
              background: url("../../assets/publicService/talentService/8.png");
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/liveOpenClass.vue